/** Composer seed when opening WhatsApp for a précommande (rupture de stock). Product ref is appended on send via WhatsAppChatContext. */
export const PREORDER_WHATSAPP_INITIAL_MESSAGE =
  "Bonjour ! Je souhaite précommander ce produit actuellement en rupture de stock. Pouvez-vous me confirmer la disponibilité, le délai et les modalités ?\n\nMerci !";
